/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".menu-container[_ngcontent-%COMP%]{position:absolute;top:50px;bottom:0;left:0;right:0}.app-version-footer[_ngcontent-%COMP%]{padding-bottom:30px;bottom:0;width:100%;text-align:center;-webkit-user-select:all;-moz-user-select:all;user-select:all}.meg-side-nav[_ngcontent-%COMP%]{width:240px}.information-divider[_ngcontent-%COMP%]{height:.5px;background-color:#202020}.menu-icons[_ngcontent-%COMP%]{left:-10px;top:0}p[_ngcontent-%COMP%]{margin-top:12px;font-weight:300;text-align:center}\n/*# sourceMappingURL=menu.component.css.map*/"];
export { styles as styles };
